const Messages = {
  custom: {
    menu: {
      configuration: "Configurações",
      theme: "Temas",
      product: "Produtos",
      category: "Categorias",
      address: "Endereços",
      opening: "Horários",
      home:"Novidades"
    },
    entities: {
      theme: {
        primaryColor: 'Cor primária',
        secondaryColor: 'Cor secundária',
        logo: 'Logo',
        icon: 'Ícone',
        active: 'Ativado',
      },
      product: {
        category: "Categoria",
        price: "Preço",
        name: "Nome",
        description: "Descrição",
        photo: "Foto",
      },
      category: {
        name: "Nome",
        order: "Ordem",
      },
      address: {
        street: "Rua",
        city: "Cidade",
        state: "Estado",
        country: "País",
        zipcode: "CEP",
        phone: "Telefone",
        whatsapp: "WhatsApp",
        delivery: "Entrega",
      },
    }
  }
}

export default Messages;